/* @flow */

const accountRoutes = {
  archiveAccount: 'accounts/:accountGuid/archive',
  impersonateLogin: 'impersonate-login/:accountGuid',
  impersonateView: 'impersonate-view/:accountGuid',
  disableUserAccess: 'accounts/:accountGuid/disable-users-access',
  enableUserAccess: 'accounts/:accountGuid/enable-users-access',
  removeUserAccess: 'accounts/:accountGuid/revoke-users-access',
  changeUserRole: 'accounts/:userGuid/change-role',
  locationsByCompany: '/accounts/:accountGuid/location/:companyGuid/:countryGuid/:locationGuid',
  activity: 'accounts/:accountGuid/activity',
  companies: 'accounts/:accountGuid/companies',
};

export default accountRoutes;
